import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Box,
  Typography,
  Chip,
  IconButton
} from "@mui/material";
import { MdDeleteForever } from "react-icons/md";

const BannerCard = ({ banner, onEdit, onDelete }) =>
  <Card
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transition: "transform 0.2s, box-shadow 0.2s",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.15)"
      }
    }}
  >
    <CardMedia
      component="img"
      height="140"
      image={banner.image}
      alt={banner.type || "Banner"}
      sx={{ objectFit: "cover" }}
      onClick={() => onEdit && onEdit(banner)}
    />
    <CardContent sx={{ flexGrow: 1 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={1}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{ fontFamily: "Mulish, sans-serif", fontWeight: 700 }}
        >
          {banner.type
            ? banner.type.charAt(0).toUpperCase() + banner.type.slice(1)
            : "Banner"}
        </Typography>
        <Chip
          label={banner.status}
          size="small"
          color={banner.status === "active" ? "success" : "warning"}
        />
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="body2"
          sx={{ fontFamily: "Mulish, sans-serif", fontWeight: 600 }}
        >
          Position: {banner.position}
        </Typography>
        <Box>
          <IconButton
            size="small"
            color="error"
            onClick={() => onDelete && onDelete(banner)}
          >
            <MdDeleteForever style={{ color: "red", fontSize: "1.4rem" }} />
          </IconButton>
        </Box>
      </Box>
    </CardContent>
  </Card>;

export default BannerCard;
